import { Component, OnInit } from '@angular/core';
import {subject_lang} from './../../language/subject';
import { ActivatedRoute } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-subject',
  templateUrl: './subject.component.html',
  styleUrls: ['./subject.component.scss']
})
export class SubjectComponent implements OnInit {
  lang="TH";
  constructor(private route:ActivatedRoute,private service:MyserviceService) { }
  actions=[
    {id:0,name:"title",url:""},
    {id:1,name:"edit_subject",url:"subject/update"},
    {id:2,name:"create_subject",url:"subject/create"},
    {id:3,name:"delete_subject",url:"subject/delete"}
  ];
  subject={sub_id:"",subject_text:""}
  search_text="";
  all_subject:any=[];
  isLoading=false;
  action=this.actions[0];
  submitted=false;
  ngOnInit() {
    this.refresh();
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        // this.language=cus_lange[this.lang];
      }else{
        // this.language=cus_lange[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }
  subjects(){
    var subjects=this.all_subject.filter((item)=>{

      return item.sub_id.toLowerCase().indexOf(this.search_text.toLowerCase())>-1
      || item.subject_text.toLowerCase().indexOf(this.search_text.toLowerCase())>-1
    });
    return subjects;

  }

  $t(text){
    try{
      if(subject_lang[this.lang][text]==undefined){
        return text;
      }else{
        return subject_lang[this.lang][text];
      }
    }catch(e){
      return text;
    }
  }
  add(){
    this.action=this.actions[2];
    this.service.postData({},"subject/getId").then((result:any)=>{
      this.subject.sub_id=result.max_id
    })
  }
  refresh(){
    this.subject={sub_id:"",subject_text:""}
    this.search_text="";
    this.action=this.actions[0];
    this.submitted=false;
    this.service.postData({},"subject/get").then((result:any)=>{
      console.log(result);
      this.all_subject=result.data;
    })
  }
  invalid(){
    var require=x=>{
      return this.submitted&&this.subject[x]=="";
    }
    return{
      subject_text:require("subject_text")
    }
  }

  isValid(){
    return !this.invalid().subject_text
  }
  edit(item){
    this.subject=item;
    this.action=this.actions[1];
  }
  save(){
    this.submitted=true;
    if(this.isValid()){
      this.service.postData(this.subject,this.action.url).then((result:any)=>{
        if(!result.code){
          Swal.fire({
            title:  this.$t('saved'),
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer:2000
          }).then((result)=>{
           this.refresh();
          })
        }
      })
    }
    // console.log(this.invalid());
  }
  delete_subject(item){
    Swal.fire({
      title: this.$t('delete_title'),
      text: this.$t('delete_warning'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.$t('delete'),
      cancelButtonText: this.$t('cancel')
    }).then((result) => {
      if (result.value) {
        this.service.postData(item, "subject/delete").then((result:any) => {
          if(!result.code){
            Swal.fire({
                  title: this.$t('deleted'),
                  text: '',
                  type: 'success',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer:2000
            }).then((result) => {
                    this.refresh();
            })
          }
        }, err => {
          window.location.href=this.service.start_host
        })
      }
    })
  }
}
